import { useCallback } from 'react';
import { useWorkspace } from '~/contexts';
import { useClientFilters, useMemberFilters, useProjectFilters, useProjectRoleFilters } from '~/hooks';
import useTaskFilters from '~/hooks/useTaskFilters';
import useTimeFilters from '~/hooks/useTimeFilters';
import { QueryString } from '~/utils';

export default function useTimeEntriesReportURL({ params = {}, query = {} } = {}) {
  const { workspace } = useWorkspace();

  const clientFilters = useClientFilters();
  const projectFilters = useProjectFilters();
  const memberFilters = useMemberFilters();
  const taskFilters = useTaskFilters();
  const roleFilters = useProjectRoleFilters();
  const timeFilters = useTimeFilters();

  const url = useCallback(
    (p = {}) =>
      `/app/${workspace.key}/reports/time-entries?${new QueryString(
        {
          start: params.period?.start ?? params.start ?? 'not_set',
          end: params.period?.end ?? params.end ?? 'not_set',
          currency: params.currency ?? undefined,
          ...clientFilters.mapClickThroughParams(params),
          ...projectFilters.mapClickThroughParams(params),
          ...memberFilters.mapClickThroughParams(params),
          ...taskFilters.mapClickThroughParams(params),
          ...roleFilters.mapClickThroughParams(params),
          ...timeFilters.mapClickThroughParams(params),
          ...query,
          ...p,
        },
        { multi: true },
      ).toString()}`,
    [params, workspace.key, clientFilters, projectFilters, memberFilters, taskFilters, roleFilters, timeFilters, query],
  );

  return url;
}
